import React, { useState, useEffect, Fragment } from 'react';
import { useSelector } from 'react-redux';
import EmptyAlert from '../components/EmptyAlert';
import Tiles from '../components/Tiles';
import { accreditedCmeService } from '../services/apiServices';
import { SpinLoader } from '../utilities';
import InfiniteScroll from 'react-infinite-scroll-component';
import { isMobile } from 'react-device-detect';
import MetaDecorators from '../components/MetaDecorators';

function ViewAllLanding() {
  const { domainDetails } = useSelector((state) => state.listings);
  const [accreditedCmes, setAccreditedCmes] = useState({});
  const [accreditedCmesList, setAccreditedCmesList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(undefined);
  const [apiError, setApiError] = useState(false);

  useEffect(() => {
    setAccreditedCmes({});
    setAccreditedCmesList([]);
    setPageNumber(1);
    if (domainDetails && domainDetails.id) {
      fetchAccreditedCmes(1);
    }
  }, [domainDetails]);

  const fetchAccreditedCmes = (pageNumber, pageSize = 12) => {
    accreditedCmeService('DOC_PRO', domainDetails.id, pageNumber, pageSize)
      .then((response) => {
        setAccreditedCmes(response);
        setTotalPages(response.totalPages);
        setLoading(false);
        setApiError(false);
      })
      .catch((error) => {
        setLoading(false);
        setApiError(true);
      });
  };

  const fetchMoreAccreditedCmes = () => {
    if (pageNumber <= totalPages) {
      setPageNumber(pageNumber + 1);
      fetchAccreditedCmes(pageNumber + 1);
    }
  };

  useEffect(() => {
    if (accreditedCmes && accreditedCmes.filterResponse) {
      setAccreditedCmesList([...accreditedCmesList, ...accreditedCmes.filterResponse]);
    }
  }, [accreditedCmes]);

  return loading ? (
    <SpinLoader />
  ) : accreditedCmesList.length === 0 || apiError ? (
    <EmptyAlert message={apiError && 'Something went wrong! Please try again.'} />
  ) : (
    <Fragment>
      <MetaDecorators />
      <InfiniteScroll
        dataLength={accreditedCmesList.length}
        next={fetchMoreAccreditedCmes}
        hasMore={accreditedCmes && !accreditedCmes.isLast}
        loader={<SpinLoader />}
        endMessage={<p className='noMoreResults'>Yay! You have seen it all</p>}
      >
        <div className='tilesWrapper'>
          <h2>Trending Accredited CMEs {accreditedCmes && accreditedCmes.count && <div className='totalResults'>{accreditedCmes.count} results</div>}</h2>
          <div className='tilesGrid tilesGridAlign'>
            {accreditedCmesList.length > 0 &&
              accreditedCmesList.map((items, index) => {
                return (
                  <Tiles
                    key={index}
                    courseId={items.id}
                    title={items.name}
                    media={window.innerWidth < 769 && items.portraitThumbnail ? items.portraitThumbnail : items.landscapeThumbnail ? items.landscapeThumbnail : items.thumbnail}
                    courseSlug={items.slug}
                    speciality={items.specialities}
                    experts={items.experts ? items.experts : []}
                    platformType={items.productType}
                    index={index}
                  />
                );
              })}
          </div>
        </div>
      </InfiniteScroll>
    </Fragment>
  );
}

export default ViewAllLanding;
